import { Decimal } from 'decimal.js';

// fix 0.3 % 0.1 = 0.09999999999999998
export function safeMod(x: number, y: number) {
	return Decimal.mod(x, y).toNumber();
}
